import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';

import styles from './LongTextArea.module.scss';

class LongTextArea extends Component {
    render() {
        const { value, onChange, maxLength, length, name, label, error, required, rows} = this.props;
        return (
            <span>
                <Form.TextArea className={styles.textAreaField} maxLength={maxLength} length={length} name={name}
                    label={label} onChange={onChange} value={value} required={required} error={error} rows={rows || 3}
                    style={{ minHeight: '36px', padding: '10px' }} />
                <p className={styles.textareafooter}>
                    {length}/{maxLength}
                </p>
            </span>
        );
    }
}


export default LongTextArea;